import { render } from "./imageHeader.vue?vue&type=template&id=37aff522"
import script from "./imageHeader.vue?vue&type=script&lang=js"
export * from "./imageHeader.vue?vue&type=script&lang=js"

import "./imageHeader.vue?vue&type=style&index=0&id=37aff522&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__